import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import TextBlock from '../text-block/text-block.component';
import DeleteIcon from '../../icons/delete-icon';
import FormatService from '../../services/format-service';
import useStylesUploadFilePreviewItem from './upload-file-preview-item.styles';

const UploadFilePreviewItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const PREVIEW_NAME_LIMIT: number = 20;

  const {
    isInline,
    uploadFile,
    uploadFileIndex,
    previewNameLimit,
    onFileDeleteClick,
  } = props;

  const { classes } = useStylesUploadFilePreviewItem();

  const deleteButtonInlineClassName: string | undefined = isInline
    ? classes.uploadFilePreviewItemDeleteButtonInline : undefined;

  return (
    <div>
      <TextBlock>
        {FormatService.formatLimitedString(uploadFile.name, previewNameLimit || PREVIEW_NAME_LIMIT)}
      </TextBlock>
      <ActionButton
        className={FormatService.formatClassNames(
          classes.uploadFilePreviewItemDeleteButton, deleteButtonInlineClassName,
        )}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onFileDeleteClick(
            event,
            uploadFileIndex !== undefined && uploadFileIndex >= 0 ? uploadFileIndex : null,
          );
        }}
      >
        <DeleteIcon />
      </ActionButton>
    </div>
  );
});

export default UploadFilePreviewItem;
